<template>
  <div>
    <!-- tab开始 -->
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="全部" name="all"></el-tab-pane>
      <el-tab-pane label="最近7天" name="weekproduction"></el-tab-pane>
      <el-tab-pane label="最近30天" name="moonproduction"></el-tab-pane>
    </el-tabs>
    <!-- tab结束 -->
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @resetBtn="resetBtn"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:tdate>
        <el-date-picker
          v-model="filters.tdate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>

      <template v-slot:warehouseId>
        <el-select
          multiple
          filterable
          v-model="filters.warehouseId"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in warehouses"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:realName>
        <el-select
          multiple
          filterable 
          v-model="filters.realName"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in userList"
            :label="item.realName"
            :value="item.realName"
            :key="item.realName"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:operationType>
        <el-select
          multiple
          v-model="filters.operationType"
          placeholder="请选择"
        >
          <el-option
            v-for="item in OperationTypeList"
            :label="item.text"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </template>

      <template slot-scope="scope" slot="showDetail">
        <el-link
          :underline="false"
          type="primary"
          @click.native="batchesDetail(scope.row)"
          >明细
        </el-link>
      </template>
    </TwTable>
    <LogDialog
      :logConfig="InOutDetailTableConfig"
      :showLog="showLogInOut"
      :requestData="{
        warehouseID: currentRow.warehouseID,
        operationDate: currentRow.operationDate,
        operatorUser: currentRow.operator,
        operationType: currentRow.operationType,
      }"
      :requestApi="'/ProductionReport/GetWareProductionDetail'"
      :requestMethod="'get'"
      v-if="showLogInOut"
      @showDialog="showDialogInOut"
    ></LogDialog>
    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{ businessType: 32, businessCode: currentRow.ioDataNo }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>

    <!-- 预览图片 -->
    <div>
      <viewer :images="srcList" class="viewer" ref="viewer" @inited="inited">
        <img v-for="(src, index) in srcList" :src="src" :key="index" />
      </viewer>
    </div>
  </div>
</template>
<style>
.viewer-list > li {
  width: 80px;
}
.viewer {
  display: none;
}
</style>
<script>
import { getSignForImage } from "@/api/mobile/signIn_api";
import {
  GetReceivingProductionOperationTypeList,
} from "@/api/report/receivingProductionReport.js";
import { GetWareProductionReport,WareProductionExport } from "@/api/report/wareProductionReport.js";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import axios from "axios";
import { thereAre } from "util/util";
import LogDialog from "../../components/TwTable/components/logDialog";
import { getOperatorInfo } from "@/api/api.js";
export default {
  components: { LogDialog, TwTable },
  mixins: [TwTable_mixins],
  data() {
    return {
      activeName: "all",
      showLogInOut: false,
      warehouses: [],
      userList: [],
      InOutDetailTableConfig: {
        title: "绩效明细",
        width: "80%",
        loading: true, // 显示loading状态
        showPage: true,
        column: [
          // 表格列配置
          {
            prop: "warehouseName",
            label: "仓库",
            align: "center",
            minWidth: "120",
          },
          {
            prop: "sourceNumber",
            label: "单据编号",
            align: "center",
            minWidth: "120",
          },
          {
            prop: "operator",
            label: "操作人",
            align: "center",
            minWidth: "80",
          },
          {
            prop: "operationTypeDesc",
            label: "操作类型",
            align: "center",
            minWidth: "90",
          },
          {
            prop: "totalVolume",
            label: "操作体积(CBM)",
            align: "center",
            minWidth: "100",
          },

          {
            prop: "totalWeight",
            label: "操作重量(KG)",
            align: "center",
            minWidth: "100",
          },
          {
            prop: "pcs",
            label: "操作Pcs数",
            align: "center",
            minWidth: "100",
          },
          {
            prop: "palletQty",
            label: "操作托盘数",
            align: "center",
            minWidth: "100",
          },
          {
            prop: "boxCount",
            label: "操作件数",
            align: "center",
            minWidth: "100",
          },
          
          {
            prop: "operationDateDesc",
            label: "操作时间",
            align: "center",
            minWidth: "120",
          },
        ],
      },
      tableConfig: {
        showResetButton: true,
        showSummary:true,
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: false, // 显示操作栏
        operate: {
          //操作栏配置
          align: "center",
          width: "120",
          options: [
            {
              prop: "resynchronize",
              name: "重新同步",
              size: "small",
              type: "text",
              slot: true,
            },
            // {
            //   name: "日志",
            //   size: "small",
            //   type: "text",
            //   event: "getbusinessLoglist", // 操作的事件名
            // },
          ],
        },
        column: [
          // 表格列配置
          {
            prop: "operator",
            label: "操作人",
            align: "center",
            minWidth: "80",
          },
          {
            prop: "operationTypeDesc",
            label: "操作类型",
            align: "center",
            minWidth: "100",
          },
          {
            prop: "operatorQty",
            label: "操作单据总数",
            align: "center",
            minWidth: "100",
          },
          {
            prop: "totalVolume",
            label: "操作体积(CBM)",
            align: "center",
            sortable: false,
            minWidth: "100",
          },
          {
            prop: "totalWeight",
            label: "操作重量(KG)",
            align: "center",
            sortable: false,
            minWidth: "100",
          },
          {
            prop: "palletQty",
            label: "操作托盘数",
            align: "center",
            sortable: false,
            minWidth: "100",
          },
          {
            prop: "boxCount",
            label: "操作件数",
            align: "center",
            sortable: false,
            minWidth: "80",
          },
           {
            prop: "pcs",
            label: "操作Pcs数",
            align: "center",
            minWidth: "100",
          },
          {
            prop: "warehouseName",
            label: "仓库名称",
            slot: false,
            minWidth: "140",
          },

          {
            prop: "operationDateDesc",
            label: "日期",
            sortable: false,
            minWidth: "110",
          },
          {
            prop: "showDetail",
            label: "查看",
            align: "center",
            sortable: false,
            slot: true,
            minWidth: "100",
          },
        ],
      },
      searchData: {
        //搜索列配置

        search: [
          {
            type: "select",
            key: "warehouseId",
            prop: "warehouseId",
            label: "仓库",
            multiple: true,
            slot: true,
            placeholder: "请选择仓库",
            option: this.warehouses,
          },
          {
            type: "select",
            key: "realName",
            prop: "realName",
            label: "操作人",
            multiple: true,
            slot: true,
            placeholder: "",
            option: this.userList,
          },
          {
            type: "select",
            key: "operationType",
            prop: "operationType",
            label: "操作类型",
            multiple: true,
            slot: true,
            placeholder: "操作类型",
            option: this.OperationTypeList,
          },
          {
            key: "tdate",
            prop: "tdate",
            slot: true,
            label: "日期",
          },
        ],
        ///高级搜索配置
        moreSearch: [],
      },
      buttonList: [],

      //-------------
      ioTypeIDList: [], //出入库类型
      ioStatusList: [], //状态
      synchStatusList: [], //同步状态
      srcList: [], //图片路径
      proListVisible: false,
      stockIODataList: [],
      departmentList: [],
      OperationTypeList: [],
    };
  },
  methods: {
    showDialogInOut() {
      this.showLogInOut = !this.showLogInOut;
    },
    handleClick(tab, event) {
      console.info(this.activeName);
      if ((this.activeName == "all")) {
        this.filters.tdate = ["", ""];
      }
      if ((this.activeName == "weekproduction")) {
        const today = new Date();
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 7);
        this.filters.tdate = [
          this.formatDate(sevenDaysAgo),
          this.formatDate(today),
        ];
      }
      if ((this.activeName == "moonproduction")) {
        const today = new Date();
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 30);
        this.filters.tdate = [
          this.formatDate(sevenDaysAgo),
          this.formatDate(today),
        ];
      }

      this.newfilters = JSON.parse(JSON.stringify(this.filters));
      this.initTable();
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    inited(viewer) {
      this.$viewer = viewer;
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    resetBtn() {
      this.filters = {
      };
    },
    //查询列表
    initTable() {
      const { warehouseId, tdate, operationType, realName } = this.newfilters;

      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        OperationType: thereAre(operationType),
        warehouseId: thereAre(warehouseId),
        realName: thereAre(realName),
      };

      if (tdate != null && tdate != "null") {
        para.startdate = tdate[0];
        para.enddate = tdate[1];
      }
      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      GetWareProductionReport(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;
     const { warehouseId, tdate, operationType, realName } = this.newfilters;
      let para = {
        page: 1,
        pageSize: 60001,
        OperationType: thereAre(operationType),
        warehouseId: thereAre(warehouseId),
        realName: thereAre(realName),
      };

       if (tdate != null && tdate != "null") {
        para.startdate = tdate[0];
        para.enddate = tdate[1];
      }

      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: WareProductionExport,
        method: "post",
        data: para,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },
    //查询明细
    batchesDetail(rows) {
      this.currentRow = rows;
      this.showLogInOut = true;
    },
    getImage(id) {
      const data = {
        signForID: id,
      };
      this.showPreviewImg = false;
      this.srcList = [];

      const loading = this.$loading({
        lock: true,
        text: "图片加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      getSignForImage(data).then((res) => {
        loading.close();
        if (res.status === 200 && res.success) {
          this.showPreviewImg = true;
          const { response } = res;
          response.forEach((item, i) => {
            response[i] = `data:image/png;base64,${item}`;
          });

          this.srcList = response;
          this.$viewer.view(0);
          this.$viewer.show();
          // setTimeout(function(){
          //   document.querySelector('#ImgEle').click()
          // },500)
        } else {
          this.$message({
            message: "加载失败！",
            type: "error",
          });
        }
      });
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);

    let user = JSON.parse(window.localStorage.user);
    this.warehouses = user.warehouseList;

    //加载基础资料

    getOperatorInfo().then((res) => {
      this.userList = res.data.response;
    });

    //加载基础资料

    GetReceivingProductionOperationTypeList().then((res) => {
      this.OperationTypeList = res.data.response;
    });
  },
};
</script>